import * as React from 'react';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import {
    EventRowTitle,
    MobileParticipant,
} from 'src/domains/sportsbook/webview/components/events/row/Participant.style';
import { observer } from 'src/utils/mobx-react';
import { EventListGroupEventItemType } from 'src_common/common/websocket2/modelsApi/EventsCollectionQuery';

interface ParticipantPropsType {
    smallEvent: EventListGroupEventItemType;
}

export const Participant = observer('Participant', (props: ParticipantPropsType) => {
    const { smallEvent } = props;
    const common = useCommon();
    const breakpointsState = BreakpointsState.get(common);
    const configState = ConfigComponents.get(common).config;

    const { sportsbookVariant } = configState.componentVariants;

    const eventModel = smallEvent.id2.getEventModel();

    if (eventModel === null) {
        return <EventRowTitle data-test='participant'>{smallEvent.name}</EventRowTitle>;
    }

    if (
        (breakpointsState.tablet.isBiggerOrEq === true &&
            sportsbookVariant !== DefaultComponentVariantType.SECONDARY) ||
        (eventModel.homeParticipant === null && eventModel.awayParticipant === null)
    ) {
        return <EventRowTitle data-test='participant'>{smallEvent.name}</EventRowTitle>;
    }

    let homeParticipant = eventModel.homeParticipant;
    let awayParticipant = eventModel.awayParticipant;

    const isAmericanFootball = eventModel.sport === 'americanfootball';
    const isBasketball = eventModel.sport === 'basketball';

    if (isAmericanFootball || isBasketball) {
        const splittedEventName = smallEvent.name.split('vs');

        homeParticipant = splittedEventName[0] ?? eventModel.homeParticipant;
        awayParticipant = splittedEventName[1] ?? eventModel.awayParticipant;
    }

    return (
        <>
            <MobileParticipant>{homeParticipant}</MobileParticipant>
            <MobileParticipant>{awayParticipant}</MobileParticipant>
        </>
    );
});
